export var PushPlatform;
(function (PushPlatform) {
    PushPlatform["ANDROID"] = "android";
    PushPlatform["IOS"] = "ios";
    PushPlatform["WEB"] = "web";
})(PushPlatform || (PushPlatform = {}));
